export const isPromiseFulfilled = <T>(
  response: PromiseSettledResult<T>,
): response is PromiseFulfilledResult<T> => response.status === "fulfilled";

export const isPromiseRejected = <T>(
  response: PromiseSettledResult<T>,
): response is PromiseRejectedResult => response.status === "rejected";

export const getValueFromPromiseResult = <T>(
  response: PromiseSettledResult<T>,
  defaultValue: T,
): T => {
  return isPromiseFulfilled(response) ? response.value : defaultValue;
};

export const getListFromPromiseResult = <T>(
  response: PromiseSettledResult<T[]>,
): T[] => {
  return getValueFromPromiseResult(response, []);
};
